import { atom } from "jotai";

export const openModalDobleFactorAutenticacionAtom = atom(false);
export const loadingAtom = atom(false);

export const usuarioIdAtom = atom(undefined);
export const codigoAtom = atom(undefined);
export const errorMessageAtom = atom(undefined);